import React, { useContext } from 'react'
import { ModalContext } from '../../../../../../../contexts'
import { Text } from '../../../../../../../components'
import { MODAL_FIELD_INFO } from '../../../../../../../constants/display'

import styles from './InfoModalBody.module.scss'

export const InfoModalBody = () => {
  // TODO update type one modal files are tsx
  const { fieldInfo } = useContext(ModalContext) as any

  const Copy = () => {
    switch (fieldInfo) {
      case MODAL_FIELD_INFO.RENTER_CURRENT_MONTHLY_RENT_COSTS:
        return (
          <>
            <Text className={styles.text}>Includes your:</Text>
            <ul className={styles.text}>
              <li>rent payment</li>
              <li>renters insurance</li>
              <li>
                other rent related fees such as parking, amenities, pets and
                maintenance.
              </li>
            </ul>
          </>
        )
      case MODAL_FIELD_INFO.CURRENT_MONTHLY_HOME_COSTS:
        return (
          <>
            <Text className={styles.text}>Includes your:</Text>
            <ul className={styles.text}>
              <li>mortgage payment</li>
              <li>property taxes</li>
              <li>homeowners insurance</li>
              <li>home maintenance costs</li>
              <li>If applicable, HOA fees (homeowner association)</li>
              <li>PMI (private mortgage insurance)</li>
            </ul>
          </>
        )
      case MODAL_FIELD_INFO.RENTER_FUTURE_MONTHLY_HOME_COSTS:
        return (
          <>
            <Text className={styles.text}>
              If you're buying a home, you may have more or less money to spend
              compared to renting. How much could you spend?
            </Text>
            <Text className={styles.text}>
              This will be used to calculate your financial insights.
            </Text>
          </>
        )
      case MODAL_FIELD_INFO.FUTURE_MONTHLY_HOME_COSTS:
        return (
          <>
            <Text className={styles.text}>
              Situations change. You may have more or less money to spend on
              your new home. How much could you spend?
            </Text>
            <Text className={styles.text}>
              This will be used to calculate your financial insights.
            </Text>
          </>
        )
      case MODAL_FIELD_INFO.DOWN_PAYMENT:
        return (
          <Text className={styles.text}>
            The sum of money you pay upfront when buying a home. In general, the
            higher your down payment, the less your loan is likely to cost. On
            average, people put down about 7% of the loan value for a home.
          </Text>
        )
      case MODAL_FIELD_INFO.YEARS_IN_HOME:
        return (
          <>
            <Text className={styles.text}>
              Typically, the longer you stay in your home, the more your costs
              are spread out over time, and the more your net worth might grow.
              People typically live in their homes for around eight years before
              selling.
            </Text>
            <Text className={styles.text}>
              This will be used to calculate your financial insights.
            </Text>
          </>
        )
      case MODAL_FIELD_INFO.RENTABLE_NIGHTS:
        return (
          <>
            <Text className={styles.text}>
              Renting your new home out for a few nights each month could help
              reduce your monthly costs. How many nights per month would you
              rent this home?
            </Text>
            <Text className={styles.text}>
              This will be used to calculate your financial insights.
            </Text>
          </>
        )
      default:
        return null
    }
  }
  return <Copy />
}
